<template>
  <!-- 项目调研 变更记录表单 -->
  <el-form ref="form" :model="form1" label-width="80px">
    <el-row>
      <el-col span="7">
        <el-form-item label="所属模块">
          <el-select clearable  v-model="form.module" filterable placeholder="请选择所属模块">
            <el-option
              v-for="item in tboptions.module"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              filterable 
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col span="7">
        <el-form-item label="功能类型">
          <el-select clearable  v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="item in tboptions.type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="原任务明细">
      <el-input v-model="form.taskdetail" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-form-item label="变更内容">
      <el-input v-model="form.contant" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-row>
      <el-col span="7">
        <el-form-item label="负责人">
          <el-select clearable  v-model="form.fzr" placeholder="请选择负责人">
            <el-option
              v-for="item in tboptions.fzr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="任务说明">
      <el-input v-model="form.instructions" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-row>
      <el-col span="7">
        <el-form-item label="周">
          <el-input-number v-model="form.week"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col span="15">
        <el-form-item label="计划日期">
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="form.bd"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="form.ed"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    tboptions: {
      // 下拉选项
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      form1: {},
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-form {
  .shzt {
    height: 42px;
    line-height: 42px;
    padding: 0 20px;
    font-weight: bold;
    span {
      color: #1b6aaa;
    }
  }
  /deep/ .el-form-item {
    .el-form-item__label {
      font-weight: bold;
    }
  }
}
</style>
